import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { ExtensionGroupDetailSaveEvent } from '../../extension-group-details/models/extension-group-detail-form-submit-event';

export const addExtensionGroup = createAction('[Add ExtensionGroup] Add ExtensionGroup');

export const createExtensionGroup = createAction(
   '[Create ExtensionGroup] Create ExtensionGroup',
   props<{ extensionGroupSave: ExtensionGroupDetailSaveEvent }>()
);

export const createExtensionGroupSuccess = createAction(
   '[API] Create ExtensionGroup Success',
   props<{ extensionGroupId: number; name: string | null }>()
);

export const createExtensionGroupFailure = createAction(
   '[API] Create ExtensionGroup Failure',
   props<SingleGraphError>()
);
